export const changeCardsIndicatorsCallCenter = (
  card1,
  card2,
  card3,
  card4,
  card5,
  card6,
  card7
) => {
  return {
    type: "CHANGE_CARDS_INDICATORS_CALL_CENTER",
    card1,
    card2,
    card3,
    card4,
    card5,
    card6,
    card7,
  };
};
